import clsx from 'clsx';

export function CategoryFilter({ categories = [], value, onChange }) {
  const items = [{ id: '__all__', name: 'الكل' }, ...categories];
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((c) => {
        const active = (value || '__all__') === (c._id || c.id);
        return (
          <button
            key={c._id || c.id}
            type="button"
            onClick={() => onChange((c._id || c.id) === '__all__' ? null : (c._id || c.id))}
            className={clsx(
              'btn',
              active && 'btn-primary',
              'text-[12px] px-3 py-1.5'
            )}
          >
            {c.name}
          </button>
        );
      })}
    </div>
  );
}
